import { render } from "./VerifikasiPopUp.vue?vue&type=template&id=0b519335&scoped=true"
import script from "./VerifikasiPopUp.vue?vue&type=script&lang=js"
export * from "./VerifikasiPopUp.vue?vue&type=script&lang=js"

import "./VerifikasiPopUp.vue?vue&type=style&index=0&id=0b519335&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b519335"]])

export default __exports__